@import 'apps/webcomponents/src/assets/common.scss';

:host {
  padding-left: calc(var(--spacer) * 4);
}
